import type { TypePolicies } from '../../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  Asset: {
    fields: {
      ancestorFolders: {
        merge: (_, incoming) => incoming,
      },
    },
  },

  VersionStackAsset: {
    fields: {
      versions: {
        merge: (_, incoming) => incoming,
      },
    },
  },
};
